"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_router_dom_1 = require("react-router-dom");
const react_intl_1 = require("react-intl");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const data = [
    { text: "pages.claims.template.title", link: "/claims/templates", icon: (0, jsx_runtime_1.jsx)(icons_material_1.MarkunreadMailbox, {}) },
    { text: "pages.claims.token.title", link: "/claims/tokens", icon: (0, jsx_runtime_1.jsx)(icons_material_1.MarkunreadMailbox, {}) },
];
const ClaimSection = () => {
    return ((0, jsx_runtime_1.jsx)(material_1.Paper, { sx: { mb: 2 }, children: (0, jsx_runtime_1.jsx)(ui_kit_1.List, { component: "nav", subheader: (0, jsx_runtime_1.jsx)(ui_kit_1.List.Subheader, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "pages.dashboard.mechanics.claim" }) }), children: data.map(({ text, icon, link }) => ((0, jsx_runtime_1.jsxs)(ui_kit_1.List.ItemButton, { component: react_router_dom_1.Link, to: link, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemIcon, { children: icon }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: text }) })] }, text))) }) }));
};
exports.ClaimSection = ClaimSection;
//# sourceMappingURL=claim.js.map